import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { c as d, I as s } from "./Section-DOeCOW54.js";
import h from "react";
import { T as m } from "./useMediaQuery-BZAMobKw.js";
const _ = "elo-chip", x = "elo-chip__text", b = "elo-mobile", t = {
  chip: _,
  "chip__icon-and-text-wrapper": "elo-chip__icon-and-text-wrapper",
  chip__text: x,
  "chip--disabled": "elo-chip--disabled",
  "left-content": "elo-left-content",
  mobile: b
}, y = h.forwardRef(
  ({ leftIcon: c, rightIcon: a, isDesktop: l = !0, children: p, ...i }, r) => {
    const n = d(
      t.chip,
      i.disabled && t["chip--disabled"],
      i.className
    );
    return /* @__PURE__ */ o("button", { ...i, ref: r, className: n, children: [
      /* @__PURE__ */ o("div", { className: t["chip__icon-and-text-wrapper"], children: [
        /* @__PURE__ */ e("div", { children: c && /* @__PURE__ */ e(s, { name: c }) }),
        /* @__PURE__ */ e(
          m,
          {
            extraClass: t.chip__text,
            type: l ? "paragraph" : "label",
            size: l ? "small" : "medium",
            children: p
          }
        )
      ] }),
      /* @__PURE__ */ e("div", { children: a && /* @__PURE__ */ e(s, { name: a }) })
    ] });
  }
);
export {
  y as C
};
